import { validateUrl } from '../../../../shared/utils/strings';
import {
    ADD_SLIDE_ITEM,
    CHANGE_ACTIVE_SLIDE,
    CHANGE_CAROUSEL_ITEM_VALUE,
    REMOVE_SLIDE,
    RESET_CAROUSEL_FIELDS,
    VALIDADE_SLIDES,
} from '../actions/actionTypes';

const carouselInitialItem = {
    description: '',
    fake_image: '',
    image: '',
    video: '',
    fileTypeExtension: '',
    position: 0,
    url_destination: '',
    resource_id: 0,
};

const initialState = {
    activeSlide: {
        0: carouselInitialItem,
    },
    carouselSlides: {
        0: carouselInitialItem,
    },
    slideWithError: false,
};


const addSlide = (state) => {
    const slidesLength = Object.values(state.carouselSlides).length;
    const newSlideIndex = Object.values(state.carouselSlides)[slidesLength - 1].position + 1;

    return {
        ...state,
        carouselSlides: {
            ...state.carouselSlides,
            [newSlideIndex]: {
                ...carouselInitialItem,
                position: newSlideIndex,
            },
        },
    };
};

const changeActiveSlide = (state, action) => {
    const newActiveSlide = state.carouselSlides[action.newActiveSlideIndex];

    return {
        ...state,
        activeSlide: {
            [action.newActiveSlideIndex]: newActiveSlide,
        },
    };
};

const validateSlides = (state) => {
    const { activeSlide, carouselSlides } = state;
    let isSlideWithError = {};

    Object.values(carouselSlides)
        .map(({
            image, position, video, url_destination: url,
        }) => {
            if (!image && !video) {
                isSlideWithError = {
                    ...isSlideWithError,
                    [position]: {
                        ...isSlideWithError[position],
                        image: true,
                        position,
                    },
                };
            }

            const isUrlValid = validateUrl(url);
            if (!url || !isUrlValid) {
                isSlideWithError = {
                    ...isSlideWithError,
                    [position]: {
                        ...isSlideWithError[position],
                        url_destination: true,
                        position,
                    },
                };
            }
            return null;
        });

    const firstItemWithError = Object.values(isSlideWithError)
        .filter((slide) => {
            if (slide.image || slide.url_destination) {
                return {
                    [slide.position]: {
                        ...slide,
                    },
                };
            }
            return null;
        });


    const newActiveSlide = Object.values(isSlideWithError).length > 0
        ? { [firstItemWithError[0].position]: carouselSlides[firstItemWithError[0].position] }
        : activeSlide;

    return {
        ...state,
        slideWithError: firstItemWithError[0],
        activeSlide: newActiveSlide,
    };
};

const changeCarouselItem = (state, action) => {
    const { carouselSlides, slideWithError } = state;
    const { carouselIndex, fieldName, value } = action;

    const newCarouselSlides = {
        ...carouselSlides,
        [carouselIndex]: {
            ...carouselSlides[carouselIndex],
            [fieldName]: value,
        },
    };

    const newSlideWithError = slideWithError
        ? {
            ...carouselSlides[carouselIndex],
            [fieldName]: value,
        }
        : null;

    return {
        ...state,
        carouselSlides: newCarouselSlides,
        activeSlide: {
            [carouselIndex]: {
                ...carouselSlides[carouselIndex],
                [fieldName]: value,
            },
        },
        slideWithError: newSlideWithError,
    };
};


const getNewActiveSlide = ({ activeSlideIndex, carouselSlides, carouselSlidesIndexes }) => {
    const activeIndex = parseInt(carouselSlidesIndexes.indexOf(`${activeSlideIndex}`), 10) - 1;
    const newActiveSlideIndex = carouselSlidesIndexes[activeIndex];
    const newActiveSlide = carouselSlides[newActiveSlideIndex];
    return { [newActiveSlideIndex]: newActiveSlide };
};

const removeSlide = (state) => {
    const { activeSlide, carouselSlides } = state;
    const carouselSlidesIndexes = Object.keys(carouselSlides);
    const activeSlideIndex = parseInt(Object.keys(activeSlide)[0], 10);

    const newSlides = Object.assign({}, carouselSlides);
    delete newSlides[activeSlideIndex];

    const newCarouselSlidesIndexes = Object.keys(newSlides);
    const firstItem = newSlides[newCarouselSlidesIndexes[0]];

    const isFirstSlide = activeSlideIndex === parseInt(carouselSlidesIndexes[0], 10);
    const newActiveSlide = isFirstSlide
        ? { [newCarouselSlidesIndexes[0]]: firstItem }
        : getNewActiveSlide({ activeSlideIndex, carouselSlides, carouselSlidesIndexes });

    return {
        ...state,
        carouselSlides: { ...newSlides },
        activeSlide: newActiveSlide,
    };
};

const resetCarouselFields = () => ({
    ...initialState,
});

const carouselReducer = (state = initialState, action) => {
    let newState = {};
    switch (action.type) {
    case ADD_SLIDE_ITEM: newState = addSlide(state); break;
    case CHANGE_ACTIVE_SLIDE: newState = changeActiveSlide(state, action); break;
    case CHANGE_CAROUSEL_ITEM_VALUE: newState = changeCarouselItem(state, action); break;
    case VALIDADE_SLIDES: newState = validateSlides(state); break;
    case REMOVE_SLIDE: newState = removeSlide(state); break;
    case RESET_CAROUSEL_FIELDS: newState = resetCarouselFields(state); break;
    default:
        newState = state;
    }
    return newState;
};

export default carouselReducer;
